// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2379":"e3304a11b68203f1","2888":"468c2888bc26689e","9652":"57c958523bddc4a1"}[chunkId] + ".css";
};